export const getRatingStyle = (value: number): string => {
  if (value >= 8.5) {
    return '#00BC4B';
  }

  if (value >= 7) {
    return '#6AC140';
  }

  return '#888C93';
};
